<template>
  <div>
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-model-item label="选择渠道">
              <a-select
                show-search
                placeholder="请选择渠道"
                option-filter-prop="children"
                style="width: 200px;margin-left: auto"
                :filter-option="filterOption"
                v-model="appId"
                @change="handleChange"
                id="aa"
              >
                <a-select-option
                  v-for="item in wechatApp"
                  :key="item.appId"
                  :value="item.appId"
                  >{{ item.name }}</a-select-option
                >
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form>
    </div>
  </div>
</template>
<script>
import { getAction } from '@/api/manage';
export default {
  name: 'channel-search',
  props: {
    wechatType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      activeKey: '1',
      queryParam: {},
      wechatApp: [],
      appId: ''
    };
  },
  components: {},
  mounted() {
    this.getWechatApp();
  },
  methods: {
    handleChange(value) {
      for (let i in this.wechatApp) {
        if (this.wechatApp[i].appId == value) {
          this.$emit('wechatAppId', this.wechatApp[i].appId);
        }
      }
      this.appId = value;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    getWechatApp() {
      getAction(process.env.VUE_APP_CMS_WECHAT + '/wechatApp/queryByType', {
        type: this.wechatType
      }).then(res => {
        if (res.success) {
          this.wechatApp = res.result;
          this.appId = res.result[0].appId;
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
